
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#F2382F","fill-rule":"evenodd"}},[_c('circle',{attrs:{"opacity":".133","cx":"8","cy":"8","r":"7"}}),_c('circle',{attrs:{"cx":"8","cy":"8","r":"3"}})])])
          )
        }
      }
    